import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import type { AbgleichZeile } from '../../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';
import { mitarbeiterName } from './mitarbeiterName';
import { StandortSelect } from './StandortSelect';

export function EinzelnZuordnung({
  zeilen,
  standorte,
  zuordnung,
  onZuordnungChange,
}: {
  zeilen: AbgleichZeile[];
  standorte: string[];
  zuordnung: Record<string, string>;
  onZuordnungChange: (id: string, standort: string) => void;
}) {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>
            {t('domain.datev.abgleich.zuordnung.mitarbeiter')}
          </TableHead>
          <TableHead>{t('domain.datev.abgleich.spalten.standort')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {zeilen.map((zeile, index) => {
          const showBottomLine = index < zeilen.length - 1;
          return (
            <TableRow key={zeile.id}>
              <TableCell
                className="w-1/2"
                text={mitarbeiterName(zeile)}
                showBottomLine={showBottomLine}
              />
              <TableCell
                type="input"
                className="w-1/2"
                showBottomLine={showBottomLine}>
                <label
                  className="sr-only"
                  htmlFor={`standort-zuordnung-${zeile.id}`}>
                  {t('domain.datev.abgleich.spalten.standort')}:
                </label>
                <StandortSelect
                  id={`standort-zuordnung-${zeile.id}`}
                  value={zuordnung[zeile.id]}
                  standorte={standorte}
                  onChange={(standort) => onZuordnungChange(zeile.id, standort)}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
